// AppHeader.js

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Drawer, Menu, Row, Layout } from "antd";
import { MenuOutlined } from "@ant-design/icons";
const { Header } = Layout; // Destructure Header from Layout

const AppHeader = ({ isMobile, showDrawer, onClose, visible }) => {
  return (
    <Header style={{ backgroundColor: "white" }}>
      <Row justify="space-between" align="middle">
        <Col>
          <Row>
            {!isMobile && <div style={{ width: "45px" }} />}
            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="Logo"
              style={{ height: "40px", margin: "10px" }}
            />
            <span style={{ fontSize: "20px", fontWeight: "bold" }}>
              Eljousour Studio
            </span>
          </Row>
        </Col>

        <Col>
          {isMobile ? (
            <>
              <Button
                type="text"
                onClick={showDrawer}
                icon={<MenuOutlined />}
              />

              <Drawer
                title="Menu"
                placement="right"
                closable={true}
                width={250}
                onClose={onClose}
                visible={visible}
              >
                <style>
                  {`
                    .custom-menu .ant-menu-item-selected {
                      background-color: white !important;
                      color: black !important;
                      font-weight: bold !important;
                    }
                    .custom-menu .ant-menu-item-selected a {
                      color: black !important;
                    }
                  `}
                </style>
                <Menu
                  theme="light"
                  mode="vertical"
                  defaultSelectedKeys={["1"]}
                  className="custom-menu"
                >
                  <Menu.Item key="1">
                    <Link to="/">Home</Link>
                  </Menu.Item>
                  <Menu.Item key="2">
                    <Link to="/portfolio">Portfolio</Link>
                  </Menu.Item>
                  <Menu.Item key="3">
                    <Link to="/services">Services</Link>
                  </Menu.Item>
                  <Menu.Item key="4">
                    <Link to="/skills">Skills</Link>
                  </Menu.Item>
                  <Menu.Item key="5">
                    <Link to="/contact">Contact</Link>
                  </Menu.Item>
                  <Menu.Item key="6">
                    <Link to="/blog">Blog</Link>
                  </Menu.Item>
                </Menu>
              </Drawer>
            </>
          ) : (
            <Row align="middle">
              <Menu
                theme="light"
                color="#000"
                mode="horizontal"
                defaultSelectedKeys={["1"]}
                style={{
                  lineHeight: "64px",
                  fontWeight: "bold",
                  color: "grey",
                }}
              >
                <Menu.Item key="1">
                  <Link to="/">Home</Link>
                </Menu.Item>
                <Menu.Item key="2">
                  <Link to="/portfolio">Portfolio</Link>
                </Menu.Item>
                <Menu.Item key="3">
                  <Link to="/services">Services</Link>
                </Menu.Item>
                <Menu.Item key="4">
                  <Link to="/skills">Skills</Link>
                </Menu.Item>
                <Menu.Item key="5">
                  <Link to="/contact">Contact</Link>
                </Menu.Item>
                <Menu.Item key="6">
                  <Link to="/blog">Blog</Link>
                </Menu.Item>
              </Menu>
              <Button
                type="primary"
                size="large"
                color="black"
                style={{
                  marginRight: "40px",
                  marginLeft: "30px",
                  fontWeight: "bold",
                  fontSize: "13px",
                }}
              >
                Hire Us
              </Button>
            </Row>
          )}
        </Col>
      </Row>
    </Header>
  );
};

export default AppHeader;
